(() => {
  if (window.__dulaAddCarLoaded) return;
  window.__dulaAddCarLoaded = true;

  let floatingCartLink = null;

  const updateCartLinks = (count) => {
    document.querySelectorAll('.dula-cart-link').forEach((link) => {
      link.dataset.cartCount = String(count);
      const badge = link.querySelector('.dula-cart-badge');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count <= 0;
      } else {
        link.textContent = count > 0 ? `Cart (${count})` : 'Cart';
      }
      link.setAttribute('aria-label', count > 0 ? `Cart, ${count} items` : 'Cart');
    });
  };

  const getHeaderCartLink = () =>
    document.querySelector('.dula-mobile-cart-link:not(.dula-floating-cart-link)') ||
    document.querySelector('.dula-header .dula-cart-link');

  const isElementInViewport = (element) => {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || '1') > 0
    );
  };

  const createFloatingCartLink = () => {
    if (floatingCartLink) return floatingCartLink;

    const source = getHeaderCartLink();
    if (!source) return null;

    const count = Number(source.dataset.cartCount || source.querySelector('.dula-cart-badge')?.textContent || '0');
    const link = document.createElement('a');

    link.className = 'dula-floating-cart-link dula-cart-link';
    link.href = source.href || '/cart';
    link.dataset.cartCount = String(count);
    link.setAttribute('aria-label', count > 0 ? `Cart, ${count} items` : 'Cart');
    link.innerHTML = `
      <svg class="dula-mobile-cart-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3.4 5.2h2.4l2.3 10.7a2 2 0 0 0 2 1.6h6.8a2 2 0 0 0 1.9-1.4l1.7-6.2H7.1"></path>
        <path d="M10 21a1.4 1.4 0 1 0 0-2.8A1.4 1.4 0 0 0 10 21Z"></path>
        <path d="M17.3 21a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"></path>
      </svg>
      <span class="dula-cart-badge"${count <= 0 ? ' hidden' : ''}>${count}</span>
    `;

    document.body.appendChild(link);
    floatingCartLink = link;
    return link;
  };

  const syncFloatingCartState = () => {
    const floating = createFloatingCartLink();
    const headerCart = getHeaderCartLink();

    if (!floating || !headerCart) return;

    const hasFloatingCartPage = document.querySelector('.dula-addcar-list, .dula-product');
    // 浮动购物车在 PC 与移动端均启用 (原仅移动端);触发条件: 在加购页 + 顶部购物车滚出视野
    const shouldShow = hasFloatingCartPage && !isElementInViewport(headerCart);

    floating.classList.toggle('is-visible', Boolean(shouldShow));
    floating.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    floating.tabIndex = shouldShow ? 0 : -1;
  };

  let floatingCartTicking = false;
  const requestFloatingCartSync = () => {
    if (floatingCartTicking) return;

    floatingCartTicking = true;
    window.requestAnimationFrame(() => {
      floatingCartTicking = false;
      syncFloatingCartState();
    });
  };

  const getCartAnimationTarget = () => {
    if (floatingCartLink?.classList.contains('is-visible') && isElementInViewport(floatingCartLink)) {
      return floatingCartLink;
    }

    const headerCart = getHeaderCartLink();
    if (isElementInViewport(headerCart)) return headerCart;

    return floatingCartLink || createFloatingCartLink() || headerCart;
  };

  const flyToHeaderCart = (source) => {
    const target = getCartAnimationTarget();
    if (!target || !source) return;

    const sourceRect = source.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const startX = sourceRect.left + sourceRect.width / 2;
    const startY = sourceRect.top + sourceRect.height / 2;
    const endX = targetRect.left + targetRect.width / 2;
    const endY = targetRect.top + targetRect.height / 2;
    const token = document.createElement('span');

    token.className = 'dula-cart-fly-token';
    token.textContent = '1';
    token.style.left = `${startX}px`;
    token.style.top = `${startY}px`;
    document.body.appendChild(token);

    const animation = token.animate(
      [
        { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
        { transform: `translate(${endX - startX - 12}px, ${endY - startY - 12}px) scale(0.35)`, opacity: 0.2 },
      ],
      { duration: 720, easing: 'cubic-bezier(0.2, 0.75, 0.22, 1)' }
    );

    animation.onfinish = () => token.remove();
  };

  window.DulaCartUI = {
    updateCartLinks,
    syncFloatingCart: requestFloatingCartSync,
    flyToCart: (source) => {
      syncFloatingCartState();
      flyToHeaderCart(source);
    },
    getCartAnimationTarget,
  };

  const markButtonAdded = (button) => {
    const badge = button.querySelector('.dula-home-add-badge');
    const currentCount = Number(button.dataset.addCount || '0') + 1;

    button.dataset.addCount = String(currentCount);
    button.classList.add('is-added');
    if (badge) badge.textContent = String(currentCount);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('dula-home-add-form')) return;

    event.preventDefault();

    const button = form.querySelector('.dula-home-add-button');
    const productLink = form.closest('.dula-product-card')?.querySelector('a[href]');
    if (!button) return;

    // ---- 防连点保护 (避免高频请求触发 Shopify 人机验证 / 风控) ----
    // 1) 提交锁: 同一表单上一次加购未结束前,忽略后续提交。
    // 2) 轻微节流: 两次成功加购之间至少间隔 800ms。
    const now = Date.now();
    const lastSubmit = Number(form.dataset.lastSubmit || '0');
    if (form.dataset.submitting === '1' || now - lastSubmit < 800) {
      return;
    }
    form.dataset.submitting = '1';
    form.dataset.lastSubmit = String(now);
    button.disabled = true; // 原生禁用,双保险


    try {
      button.classList.add('is-pending');

      const addUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const cartUrl = `${window.Theme?.routes?.cart_url || '/cart'}.js`;
      const addResponse = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!addResponse.ok) throw new Error('Add to cart failed');

      const cartResponse = await fetch(cartUrl, {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();

      markButtonAdded(button);
      flyToHeaderCart(button);
      window.DulaCartUI?.showAdded?.();
      updateCartLinks(cart.item_count || 0);
      requestFloatingCartSync();
    } catch (error) {
      // 加购失败时不再强制整页跳转(避免与验证页冲突),改为温和回退到商品页。
      if (productLink?.href) {
        window.location.assign(productLink.href);
        return; // 跳转中,保持锁定,不解锁
      }
    } finally {
      // 仅在未跳转的情况下解锁,允许下一次加购。
      button.classList.remove('is-pending');
      button.disabled = false;
      form.dataset.submitting = '0';
    }
  });


  window.addEventListener('scroll', requestFloatingCartSync, { passive: true });
  window.addEventListener('resize', requestFloatingCartSync);
  document.addEventListener('DOMContentLoaded', requestFloatingCartSync, { once: true });
  requestFloatingCartSync();
})();

